export const DeviceStatusEnum = {
  true: '在线',
  false: '离线'
}

export const DeviceStatusStyleEnum = {
  true: 'success',
  false: 'danger'
}
